import React from 'react';
import { useStyles } from './styles';
import { Box, Container, Typography, Button } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { COLOR_PURPLE_HOVER } from 'styles/variables/colors';
import { setLocale } from 'utils/locale';

import en from './locales/en';
import ja from './locales/en';
import zh from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';

export default function GalleryBanner() {
  const classes = useStyles();
  const router = useRouter();
  const { locale } = router;
  const t = setLocale(locale, { en, es, fr, it, ja, zh });

  return (
    <>
      <Box bgcolor={COLOR_PURPLE_HOVER}>
        <Container>
          <Box pt={5}>
            <Typography className={classes.textWhite} align="center" component="h2" variant="h5">
              <b>{t.title}</b>
            </Typography>
          </Box>

          <Box mt={1} pb={8}>
            <Typography align="center" className={classes.textWhite}>
              {t.subTitle}
            </Typography>
          </Box>

          <Box className={classes.containerBoxes}>
            <Box className={classes.mainBox}>
              <Typography className={classes.numberBox}>
                <b>01</b>
              </Typography>

              <Typography>{t.stepOne}</Typography>
            </Box>

            <ArrowForwardIos className={classes.arrowIcon} />

            <Box className={classes.mainBox}>
              <Typography className={classes.numberBox}>
                <b>02</b>
              </Typography>

              <Typography>{t.stepTwo}</Typography>
            </Box>

            <ArrowForwardIos className={classes.arrowIcon} />

            <Box className={classes.mainBox}>
              <Typography className={classes.numberBox}>
                <b>03</b>
              </Typography>

              <Typography>{t.stepThree}</Typography>
            </Box>
          </Box>

          <Typography align="center" className={classes.textWhite}>
            {t.text}
          </Typography>

          <Box display="flex" justifyContent="center" mt={1.5} pb={8}>
            <Button
              onClick={() => router.push('/icon-request')}
              className={classes.btnStartCreation}
            >
              <b>{t.textButton}</b>
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
}
